"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ATTACHMENT_TYPE = void 0;
var ATTACHMENT_TYPE = {
  AUDIO_RECORDING: 'AudioRecording',
  AUDIO_TRANSCRIPTION_: 'AudioTranscription',
  TEXT: 'Text',
  SOURCE_DOCUMENT: 'SourceDocument',
  RENDERED_DOCUMENT: 'RenderedDocument',
  MMS_ATTACHMENT: 'MmsAttachment',
  FAX_ATTACHMENT: 'FaxAttachment'
};
exports.ATTACHMENT_TYPE = ATTACHMENT_TYPE;
//# sourceMappingURL=constants.js.map
